export const TOKEN = process.env.REACT_APP_TOKEN
export const NFT = process.env.REACT_APP_NFT
export const USER_REWARD_URL = process.env.REACT_APP_USER_REWARD_URL
